import { PickerItemProps } from "../../types/PickerTypes";
import { Buildings } from "@phosphor-icons/react";

interface RenovationProject {
  id: number;
  title: string;
  description?: string;
  status: string;
  buildingId?: string;
}

export const RenovationProjectItem = ({ item, isSelected, onSelect }: PickerItemProps<RenovationProject>) => {
  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-4 py-3 hover:bg-neutral-100 transition-colors flex items-center gap-3 ${
        isSelected ? "bg-moss-primary/10" : ""
      }`}
    >
      <div className="flex-shrink-0">
        <Buildings size={20} weight="duotone" className="text-moss-primary" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="font-medium text-sm text-neutral-primary truncate">
            {item.title}
          </p>
          <span className="text-xs px-2 py-0.5 rounded bg-neutral-200 text-neutral-600">
            {item.status}
          </span>
        </div>
        {item.description && (
          <p className="text-xs text-neutral-600 truncate mt-0.5">
            {item.description}
          </p>
        )}
        {item.buildingId && (
          <p className="text-xs text-neutral-500 mt-0.5">
            Gebouw: {item.buildingId}
          </p>
        )}
      </div>
    </button>
  );
};
